import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaBan, FaCheck, FaClock, FaFileMedical, FaPills, FaQuestionCircle } from 'react-icons/fa';

const STATUS_CONFIG = {
  SOLICITADA: {
    label: 'Solicitada',
    Icon: FaClock,
    color: '#0d6efd',
    bg: '#cfe2ff',
    border: '#0d6efd',
    tooltip: 'Receita solicitada',
  },
  PRESCRITA: {
    label: 'Prescrita',
    Icon: FaFileMedical,
    color: '#1a3a6b',
    bg: '#e7eef8',
    border: '#1a3a6b',
    tooltip: 'Receita prescrita',
  },
  ENTREGUE: {
    label: 'Entregue',
    Icon: FaCheck,
    color: '#198754',
    bg: '#d1e7dd',
    border: '#198754',
    tooltip: 'Entregue pelo médico',
  },
  APANHADA: {
    label: 'Apanhada',
    Icon: FaCheck,
    color: '#0f5132',
    bg: '#d1e7dd',
    border: '#0f5132',
    tooltip: 'Entregue ao paciente',
  },
  CANCELADA: {
    label: 'Cancelada',
    Icon: FaBan,
    color: '#dc3545',
    bg: '#f8d7da',
    border: '#dc3545',
    tooltip: 'Pedido cancelado',
  },
  BAIXADA: {
    label: 'Baixada',
    Icon: FaPills,
    color: '#0f766e',
    bg: '#ccfbf1',
    border: '#0f766e',
    tooltip: 'Dispensada na farmácia',
  },
};

function resolverStatus(status) {
  const chave = String(status || '')
    .trim()
    .toUpperCase();
  if (STATUS_CONFIG[chave]) return STATUS_CONFIG[chave];

  const label = String(status || '').trim() || 'Sem status';
  return {
    label,
    Icon: FaQuestionCircle,
    color: '#6c757d',
    bg: '#f8f9fa',
    border: '#adb5bd',
    tooltip: `Status da receita: ${label}`,
  };
}

export function corStatusReceita(status) {
  return resolverStatus(status).border;
}

/**
 * Badge do status operacional da receita (STATUS em ARQ_RECEITA).
 *
 * @param {object} props
 * @param {string} [props.status]
 * @param {string|number} [props.id]
 */
export default function StatusReceitaBadge({ status, id }) {
  const config = resolverStatus(status);
  const { label, Icon, color, bg, border, tooltip } = config;
  const tooltipId = `tooltip-receita-${id ?? label}`;

  const badgeStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    padding: '2px 8px',
    borderRadius: '999px',
    border: `2px solid ${border}`,
    backgroundColor: bg,
    color,
    fontSize: '0.75rem',
    fontWeight: 700,
    letterSpacing: '0.02em',
    whiteSpace: 'nowrap',
    cursor: 'default',
    userSelect: 'none',
    lineHeight: 1.4,
  };

  return (
    <OverlayTrigger placement="top" overlay={<Tooltip id={tooltipId}>{tooltip}</Tooltip>}>
      <span style={badgeStyle} aria-label={tooltip}>
        <Icon size={11} aria-hidden="true" />
        {label}
      </span>
    </OverlayTrigger>
  );
}
